"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _scriptjs = _interopRequireDefault(require("scriptjs"));
var _warn = _interopRequireDefault(require("./warn"));
var _jw = _interopRequireDefault(require("../players/jw"));
var _theoplayer = _interopRequireDefault(require("../players/theo/theoplayer.config"));
var _youbora = require("../players/theo/youbora.config");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Module that provides helpers that perform any logic required
 * to instantiate a player type.
 *
 * e.g. JwPlayer requires the scripts to be fetched.
 *
 * @module registryHelpers
 */

var THEO = 'theo';
var JW = 'jw';
function playerReady(registry, type) {
  var playerRegister = registry[type];
  if (playerRegister.ready) {
    (0, _warn["default"])('Loaded ' + type + ' player more than once.');
    return;
  }
  playerRegister.ready = true;
  var players = playerRegister.players;
  for (var id in players) {
    if (players.hasOwnProperty(id)) {
      players[id]._onPlayerLoaded();
    }
  }
}
function jwInit(registry) {
  window.jwplayer = window.jwplayer || null;
  var script = '//static.hudl.com/jwplayer/' + _jw["default"]._version + '/jwplayer.js';

  // Require is on the page - load via require
  if (window.require) {
    window.require([script], function (jwplayer) {
      // Don't replace window object if it already exists
      if (!window.jwplayer) {
        window.jwplayer = jwplayer;
      }
      // Load all waiting JW players
      playerReady(registry, JW);
    });
  } else {
    (0, _scriptjs["default"])([script], 'jwplayerscript');
    _scriptjs["default"].ready('jwplayerscript', playerReady.bind(null, registry, JW));
  }
}
function theoInit(registry) {
  if (window.theoplayer && window.theoplayer.version && window.theoplayer.version.charAt(0) === '1') {
    (0, _warn["default"])('Multiple versions of THEOplayer detected. Trying to load 2.X when 1.X was already loaded. Problems may occur.');
  }
  if (window.THEOplayer && window.THEOplayer.version === _theoplayer["default"].version) {
    // THEO's already been loaded by somebody else, no need to re-fetch.
    registry.theo.youbora = window.youbora;
    playerReady(registry, THEO);
    return;
  }
  var script = _theoplayer["default"].libraryLocation + 'theoplayer.chrome.js';
  if (window.require) {
    window.require([script, _youbora.youboraPluginURL], function (theo, youbora) {
      window.THEOplayer = theo;
      window.youbora = youbora;
      registry.theo.youbora = youbora;
      playerReady(registry, THEO);
    });
  } else {
    (0, _scriptjs["default"])([script, _youbora.youboraPluginURL], 'theoplayerscript');
    _scriptjs["default"].ready('theoplayerscript', function () {
      registry.theo.youbora = window.youbora;
      playerReady(registry, THEO);
    });
  }
}
var _default = exports["default"] = {
  jwInit: jwInit,
  theoInit: theoInit
};